import React from "react";

export function MetricSkeleton({ variant = "tile" }) {
  const isHero = variant === "hero";

  return (
    <div className={`dash-metric__skeleton ${isHero ? "dash-metric__skeleton--hero" : ""}`} aria-hidden="true">
      <div className="dash-skeleton dash-skeleton--icon" />
      <div className="dash-metric__skeleton-body">
        <div className="dash-skeleton dash-skeleton--label" />
        <div className="dash-skeleton dash-skeleton--value" />
        <div className="dash-skeleton dash-skeleton--hint" />
      </div>
    </div>
  );
}

export function RowListSkeleton({ rows = 5, className = "" }) {
  return (
    <div className={`dash-row-skeleton-list ${className}`.trim()} aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="dash-row-skeleton">
          <div className="dash-skeleton dash-skeleton--row-label" />
          <div className="dash-skeleton dash-skeleton--row-values" />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 6, columns = 5 }) {
  return (
    <div className="dash-table-skeleton" aria-hidden="true">
      <div className="dash-table-skeleton__head">
        {Array.from({ length: columns }).map((_, i) => (
          <div key={i} className="dash-skeleton dash-skeleton--th" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, row) => (
        <div key={row} className="dash-table-skeleton__row">
          {Array.from({ length: columns }).map((_, col) => (
            <div key={col} className="dash-skeleton dash-skeleton--td" />
          ))}
        </div>
      ))}
    </div>
  );
}
